import { forwardRef } from "react";
const SvgDown = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M8.00049 12.8995L11.536 9.36393M8.00049 12.8995L4.46495 9.36393M8.00049 12.8995L8.00049 2.99997" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgDown);
export default ForwardRef;